import { render, staticRenderFns } from "./OwnReports.vue?vue&type=template&id=5df57880&scoped=true"
import script from "./OwnReports.vue?vue&type=script&lang=js"
export * from "./OwnReports.vue?vue&type=script&lang=js"
import "./OwnReports.vue?vue&type=style&index=0&id=5df57880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df57880",
  null
  
)

export default component.exports